<template>
    <div>
        <el-dialog title="特许经营合同补充协议-区域补充" :visible.sync="jcxy" :close-on-click-modal="false" width="800px" center>
            <el-form :inline="true" ref="addForm" :model="reqCreate" label-width="120px" :rules="rules">
                <el-form-item label="签署公司（乙方）" prop="signSealId" class="item">
                    <el-select v-model="reqCreate.signSealId" style="width:620px" @change="selectJms" clearable
                        placeholder="请选择签署公司（乙方）" filterable>
                        <el-option v-for="(item, index) in allJMSList" :key="index" :label="item.companyName"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="联系电话" prop="tel">
                    <el-input v-model="reqCreate.tel" style="width:242px" clearable maxlength="11" show-word-limit
                        placeholder="签署公司的联系电话"></el-input>
                </el-form-item>

                <el-form-item label="信用代码" prop="xinyongdaima">
                    <el-input v-model="reqCreate.xinyongdaima" style="width:242px" clearable show-word-limit
                        placeholder="签署公司的三合一社会信用代码"></el-input>
                </el-form-item>

                <el-form-item label="联系地址" prop="address">
                    <el-input v-model="reqCreate.address" style="width:620px" show-word-limit placeholder="签署公司的联系地址"
                        clearable></el-input>
                </el-form-item>

                <el-row>
                    <el-form-item label="《特许经营合同》日期" prop="q_date" class="small">
                        <el-date-picker v-model="reqCreate.q_date" type="date" style="width:620px"
                            placeholder="请选择《特许经营合同》日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>
                    <br />
                    <el-form-item label="区域" prop="area">
                        <el-input v-model="reqCreate.area" type="textarea" style="width:623px" show-word-limit
                            placeholder="请输入区域范围" :rows="3" clearable></el-input>
                    </el-form-item>
                </el-row>

                <el-form-item label="加盟商数量" prop="num">
                    <el-input v-model="reqCreate.num" type="number" style="width: 240px" show-word-limit
                        placeholder="请输入加盟商数量" clearable></el-input>
                </el-form-item>

                <el-form-item label="拓店费用">
                    <el-input v-model="reqCreate.expense" type="number" style="width: 240px" show-word-limit
                        placeholder="请输入拓店费用" clearable><template slot="append">元</template></el-input>
                </el-form-item>
                <el-row>

                    <el-form-item label="第几年开始收取">
                        <el-input v-model="reqCreate.startYear" style="width:240px" clearable show-word-limit
                            placeholder="请系统使用费第几年开始收取"><template slot="append">年</template></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="合同日期" prop="htrq">
                        <el-date-picker v-model="reqCreate.htrq" type="date" style="width:240px" placeholder="请选择合同签署日期"
                            value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>

                </el-row>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="jcxy = false">取消</el-button>
                <el-button type="primary" @click="yulan()">预览合同</el-button>
            </span>
        </el-dialog>

        <el-dialog title="合同生成预览" :visible.sync="PDFVisible" :close-on-click-modal="false" width="900px" center>
            <iframe name="ifram11" :src="contractUrl" scrolling="auto" frameborder="0"
                style="width:870px;height:800px"></iframe>

            <span slot="footer" class="dialog-footer">
                <el-button @click="PDFVisible = false">取 消</el-button>
                <el-button type="primary" @click="sendContractBtn">发送合同</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import contract from '@/script/api/contractapi';
import wmsApi from "@/script/api/wmsApi";
import globalData from '@/components/common/globaldata/global.data';
export default {
    data() {
        return {
            id: null,
            jcxy: false,
            PDFVisible: false,
            contractUrl: null,
            allJMSList: [],
            rules: {
                signSealId: [{ required: true, message: "请选择签署公司", trigger: "blur" }],
                tel: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
                xinyongdaima: [{ required: true, message: "请输入信用代码", trigger: "blur" }],
                address: [{ required: true, message: "请输入联系地址", trigger: "blur" }],
                q_date: [{ required: true, message: "请选择特许合同时间", trigger: "change" }],
                htrq: [{ required: true, message: "请选择合同签订日期", trigger: "change" }],
            },
            addField: {},
            singList: [],
            choosePerson: {}, //下拉框所选人
            reqCreate: {
                xinyongdaima: '',
                htrq: '',
                address: "",
                fraId: '',
                tel: "",
                templateNo: "",
                type: '',
                signSealId: '',
                // signSealIdBing:
                "contractNo": "",
                "createTime": "",
                "createUserId": '',
                "createUserName": "",
                "fraName": "",
                "id": '',
                "idCard": "",
                "jsonData": "",
                "processId": "",
                "remark": "",
                "signName": "",
                "state": '',

                q_date: '',
                provice: '',
                city: '',
                regin: '',
                dong: '',
                xi: '',
                nan: '',
                be: '',
                area: '',
                expense: '',
                num: '',
                startYear: ''


            },
            city: ''
        };
    },
    methods: {
        showDetail(city) {
            this.getAllJMS();
            this.jcxy = true;
            this.city = city;
            this.reqCreate = {
                xinyongdaima: '',
                htrq: '',
                address: "",
                fraId: '',
                tel: "",
                templateNo: "",
                type: '',
                signSealId: '',
                // signSealIdBing:
                "contractNo": "",
                "createTime": "",
                "createUserId": '',
                "createUserName": "",
                "fraName": "",
                "id": '',
                "idCard": "",
                "jsonData": "",
                "processId": "",
                "remark": "",
                "signName": "",
                "state": '',

                q_date: '',
                provice: '',
                city: '',
                regin: '',
                dong: '',
                xi: '',
                nan: '',
                be: '',
                expense: '',
                num: '',
                startYear: ''

            };

        },
        selectJms(id) {
            if (id == null || id == '') {
                this.choosePerson = {};
                this.reqCreate.fraId = "";
                this.reqCreate.xinyongdaima = "";
                this.reqCreate.tel = "";
                this.reqCreate.address = "";
            }
            if (id != null) {
                let ren = {};
                this.allJMSList.forEach(e => {
                    if (e.id == id) {
                        ren = e;
                    }
                })
                this.choosePerson = ren;
                this.reqCreate.fraId = ren.franchiseeId;
                this.reqCreate.xinyongdaima = ren.creditCode;
                this.reqCreate.tel = ren.tel;
                console.log(ren);
                this.reqCreate.address = ren.address;
            }
        },
        checkFm() {

            if (this.reqCreate.signSealId == null || this.reqCreate.signSealId == '') {
                this.$message.error('请选择签署公司');
                return false;
            }
            if (this.reqCreate.tel == null || this.reqCreate.tel == '' || this.reqCreate.tel.length != 11) {
                this.$message.error('请输入联电话，或输入正确的电话号码');
                return false;
            }
            if (this.reqCreate.xinyongdaima == null || this.reqCreate.xinyongdaima == '') {
                this.$message.error('请输入信用代码');
                return false;
            }

            if (this.reqCreate.address == null || this.reqCreate.address == '') {
                this.$message.error('请输入联系地址');
                return false;
            }

            if (this.reqCreate.q_date == null || this.reqCreate.q_date == '') {
                this.$message.error('请选择《特许经营合同》日期');
                return false;
            }

            if (this.reqCreate.htrq == null || this.reqCreate.htrq == '') {
                this.$message.error('请选择合同日期');
                return false;
            }

            return true;
        },
        fillTemplate() {
            let addField = {
                fraName: this.choosePerson.companyName,
                xinyongdaima: this.reqCreate.xinyongdaima,
                address: this.reqCreate.address,
                tel: this.reqCreate.tel,

                jia_year: this.reqCreate.htrq.substring(0, 4),
                jia_month: this.reqCreate.htrq.substring(5, 7) * 1,
                jia_day: this.reqCreate.htrq.substring(8, 10) * 1,
                yi_year: this.reqCreate.htrq.substring(0, 4),
                yi_month: this.reqCreate.htrq.substring(5, 7) * 1,
                yi_day: this.reqCreate.htrq.substring(8, 10) * 1,

                q_year: this.reqCreate.q_date.substring(0, 4),
                q_month: this.reqCreate.q_date.substring(5, 7) * 1,
                q_day: this.reqCreate.q_date.substring(8, 10) * 1,
                provice: this.reqCreate.provice,
                city: this.reqCreate.city,
                regin: this.reqCreate.regin,
                dong: this.reqCreate.dong,
                xi: this.reqCreate.xi,
                nan: this.reqCreate.nan,
                be: this.reqCreate.be,

                jia: '',
                yi: '',
                Contract_no: '',
                area: this.reqCreate.area,
                num: this.reqCreate.num,
                num2: this.reqCreate.num,
                expense: this.reqCreate.expense,
                startYear: this.reqCreate.startYear

            };
            this.addField = addField;
            return addField;
        },
        yulan() {
            this.$refs['addForm'].validate(valid => {
                if (valid) {
                    let temFields = this.fillTemplate();
                    this.reqCreate.tempSignData = temFields;
                    let type = 211;
                    if (this.city == '杭州') {
                        type = 216;
                    } else if (this.city == '上海') {
                        type = 211;
                    }else if (this.city == '宅景') {
                      type = 222;
                    }
                    let reqData = {
                        // cityId: this.reqCreate.cityId,
                        fraId: this.reqCreate.fraId,
                        eventType: type,
                        name: '特许经营合同补充协议-区域补充',
                        simpleFormFields: temFields
                    };

                    const loading = this.$loading({
                        lock: true,
                        text: '努力生成中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.5)'
                    });

                    contract
                        .$ajaxPreviewFile(reqData)
                        .then((res) => {
                            if (res.data.errno == 0) {
                                loading.close();
                                // console.log(res);
                                this.contractUrl = res.data.data.downloadUrl;
                                this.reqCreate.templateNo = res.data.data.templateNo; //模板编号
                                this.reqCreate.contractNo = res.data.data.contractNo; //合同编号
                                this.reqCreate.contractFileId = res.data.data.fileId; //合同文件文件id
                                this.PDFVisible = true;
                            } else {
                                loading.close();
                                this.$message({
                                    showClose: true,
                                    message: res.data.data,
                                    type: 'warning',
                                    duration: 8000
                                });
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                }
            })
        },
        sendContractBtn() {
            const loading = this.$loading({
                lock: true,
                text: '发送合同中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });

            this.reqCreate.fraId = globalData.franchisee.id;
            this.reqCreate.createUserId = this.reqCreate.fraId;// globalData.userInfo.id;
            this.reqCreate.createUserName = globalData.userInfo.userName;
            //this.reqCreate.type = 211;
            if (this.city == '杭州') {
                this.reqCreate.type = 216;
            } else if (this.city == '上海') {
                this.reqCreate.type = 211;
            }else if (this.city == '宅景') {
              this.reqCreate.type = 222;
            }
            contract.$ajaxJmsSignContract(this.reqCreate).then((res) => {
                loading.close();
                if (res.data.errno == 0) {
                    this.$message.success('合同已发送！');
                    // this.querySearch();
                    this.$emit('querySearch');
                    this.PDFVisible = false;
                    this.jcxy = false;
                } else {
                    this.$message.warning(res.data.data);
                }
            });
        },
        getAllJMS() {
            //城市下拉框
            contract
                .$ajaxJmsgetJMSAll()
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.allJMSList = res.data.data;
                    }
                });
        },
    }
};
</script>
<style lang="">
.item .el-form-item__label{
    color:#f56c6c;
     font-weight:bold;
     font-size:10px
  }
  .small .el-form-item__label{
     font-size:10px
  }
</style>
